import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/app/store/authModule';
import AppBanner from '@/app/components/common/AppBanner.vue';
import { ref, computed, onBeforeMount } from 'vue';
import { ComplianceStatus, Individual } from 'ah-api-gateways';
import { getServices } from '@/app/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountStatusBanner',
  setup(__props) {

const authStore = useAuthStore();

const requestManager = useRequestManager().manager;

function fetchClientOwner() {
  const services = getServices();

  return requestManager
    .cancelAndNew(
      'loadOwner',
      services.individual.listIndividuals(
        {
          clientId: authStore.userData?.individual?.client?.id,
          isOwner: true,
        },
        {
          errors: { silent: true },
        }
      )
    )
    .subscribe((response) => {
      clientOwner.value = response.list[1] || null;
    });
}

const clientOwner = ref<Individual | null>(null);

const isSuspended = computed(() => authStore.complianceStatus === ComplianceStatus.SUSPENDED);

const isDeactivated = computed(() => authStore.complianceStatus === ComplianceStatus.DEACTIVATED);

const isUpdatedTermsAndConditions = computed(
  () => authStore.complianceStatus === ComplianceStatus.UPDATED_TERMS_AND_CONDITIONS
);

const isIndividualClient = computed(() => {
  return authStore.isClientUser && !authStore.isCompanyClient;
});

const isUserSignatory = computed(() => {
  return isIndividualClient.value || authStore.userData?.individual?.owner;
});

const isBannerShown = computed(() => {
  return !requestManager.anyPending && (isSuspended.value || isDeactivated.value || isUpdatedTermsAndConditions.value);
});

onBeforeMount(() => {
  if (!isUserSignatory.value) {
    fetchClientOwner();
  }
});

return { __sfc: true,authStore, requestManager, fetchClientOwner, clientOwner, isSuspended, isDeactivated, isUpdatedTermsAndConditions, isIndividualClient, isUserSignatory, isBannerShown, AppBanner }
}

})